import React, { ReactElement } from 'react';
import { Layout, Menu, Spin, Space, Dropdown, Button, Drawer } from 'antd';
import { Link, RouteChildrenProps } from 'react-router-dom';
import {
  SettingOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined
} from '@ant-design/icons';
import MainContent from './MainContent';
import { connect, ConnectedProps } from 'react-redux';
import { ActionUserRes, getUser } from '../../actions/ActionUser';
import api from '../../api';
import UserAuthPasswordChangeModal from './UserAuthPasswordChangeModal';
import { ActionConfigRes, setConfigData } from '../../actions/ActionConfig';
import { getPath } from '../../tool/route';
const { SubMenu } = Menu;
const { Header, Sider } = Layout;

export interface menuSubData {
  key: string
  title: string
  icon?: ReactElement | null
  match?: string
}

export interface menuData {
  key: string
  title: string
  icon?: ReactElement
  match?: string
  sub?: menuSubData[]
}

export interface PageState {
  collapsed: boolean
  firstHide?: boolean
  menuData: menuData[]
  openKeys: string[]
  selectedKey: string
  loading?: boolean
  mainContentKey?: string
  passwordChangeModal: {
    visible: boolean
    key?: string
  }
  windowSizeWidth?: number
  windowSizeHeight?: number
}

export interface Props {

}



export type PageProps = Props & RouteChildrenProps & ConnectedProps<typeof connector>

export interface Page {
  _initData(): Promise<void>
}


interface RootState {
  user: ActionUserRes
  config: ActionConfigRes
}

const mapState = (state: RootState) => ({
  user: state.user,
  config: state.config,
})


const mapDispatch = {
  setConfigData: setConfigData,
  getUser: getUser,
}

export const connector = connect(
  mapState,
  mapDispatch
)


class Main extends React.Component<PageProps, PageState> implements Page {




  constructor (props: Readonly<PageProps>) {
    super(props);
    const params = new URLSearchParams(props.location.search);
    let collapsed = params.get('collapsed')
    collapsed = collapsed ? JSON.parse(collapsed) : undefined
    this.state = {
      passwordChangeModal: {
        visible: false,
      },
      collapsed: Boolean(collapsed) || false,
      menuData: [
        {
          key: '/user',
          title: '用戶',
          sub: [
            getPath('/user/list'),
          ],
        },
        {
          key: '/campaign',
          title: '活動',
          sub: [
            getPath('/campaign/list'),
            getPath('/campaign/approval-record/list'),
            getPath('/campaign/vote-record/list'),
          ],
        },

        {
          key: '/payment',
          title: '支付',
          sub: [
            getPath('/payment/list'),
            getPath('/payment/payment-setting/list'),
            getPath('/payment/donation-record/list'),
            getPath('/payment/transaction-record/list'),
            getPath('/payment/kiosk-donation-record/list'),
          ],
        },
        {
          key: '/asset',
          title: '素材',
          sub: [
            getPath('/asset/list'),
          ],
        },
        {
          key: '/faq',
          title: '常見問題',
          sub: [
            getPath('/faq/list'),
          ],
        },
        {
          key: '/exhibition-work',
          title: '展覽作品',
          sub: [
            getPath('/exhibition-work/list'),
          ],
        },
        {
          key: '/system',
          title: '系統',
          sub: [
            getPath('/system/config'),
          ],
        },
      ],
      openKeys: this._getOpenKeys(props),
      selectedKey: '',

    };
  }

  _getOpenKeys = (props: PageProps) => {
    return [`/${props.location.pathname.split('/')[1] || ''}`]
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.updateWindowSize())

    this.setState = () => { }
  }

  componentDidMount() {
    this._initData()

    window.addEventListener('resize', () => this.updateWindowSize())
  }


  updateWindowSize() {
    this.setState({
      windowSizeWidth: window.innerWidth,
      windowSizeHeight: window.innerHeight,
    })
  }


  _getUser = async () => {
    const res = await this.props.getUser()
    if (res.kind !== 'ok') throw new Error(res.kind)
    return res.data
  }





  _deleteAuth = async () => {
    await api.DeleteAuth()
    return
  }

  async _initData(): Promise<void> {
    try {
      this.setState({ loading: true })
      await this._getUser()
      this.setState({ loading: false, mainContentKey: new Date().toISOString() })
    } catch (error: any) {
      console.log(error?.message)
      if (error?.message)
        this.props.history.replace('/login')
      this.setState({ loading: false })
    }
  }


  _onOpenChange = (value: string[]) => {

    this.setState({
      openKeys: [value[value.length - 1]],
      firstHide: false
    })

  };

  _getMenuView = () => {
    return (
      <Menu
        className='menu'
        selectedKeys={[this.props.location.pathname]}
        openKeys={this.state.openKeys}
        theme="dark"
        mode="inline"
        onOpenChange={(value: any) => this._onOpenChange(value)}
      >
        {
          this.state.menuData.map((menu) => {

            if (menu.sub) {
              return (
                <SubMenu
                  className='subMenu'
                  key={menu.key}
                  title={
                    <span>
                      {menu.icon}
                      <span>{menu.title}</span>
                    </span>
                  }
                >
                  {menu.sub.map((menuSub) => {
                    return (
                      <Menu.Item
                        className='subMenuItem'
                        key={menuSub.key}>
                        <Link to={menuSub.key}>
                          {menuSub.icon}
                          {menuSub.title}
                        </Link>
                      </Menu.Item>
                    )
                  })}
                </SubMenu>
              )
            } else {

              return (
                <Menu.Item
                  className='subMenuItem'
                  key={menu.key}
                >
                  <Link to={menu.key}>
                    {menu.icon}
                    <span>{menu.title}</span>
                  </Link>
                </Menu.Item>
              )

            }
          })
        }
      </Menu>
    )

  }

  render() {


    return (
      <div id="main">
        <Spin
          spinning={this.state.loading}
        >
          <Layout className='layout' style={{ minHeight: '100vh' }}>

            {this.state.windowSizeWidth && this.state.windowSizeWidth <= 767
              ? (

                <Drawer
                  className='drawer'
                  placement="left"
                  width="auto"
                  closable={false}
                  visible={!this.state.collapsed}
                  onClose={() => this.setState({ collapsed: true })}
                >
                  <Sider
                    className='sider'
                    trigger={null}
                    style={{
                      height: '100vh',
                    }}
                  >
                    <div className="logo" >
                      <div
                        className='logoName'
                      >
                        Food Angel
                      </div>
                    </div>
                    {this._getMenuView()}
                  </Sider>
                </Drawer>

              )
              : (
                <Sider
                  className='sider'
                  collapsible
                  collapsed={this.state.collapsed}
                  trigger={null}
                  style={{ overflowX: 'hidden' }}
                >
                  <div className="logo" >
                    {/* <img
                      className='logoImg'
                      src={config.REACT_APP_DEV_ENV === 'sit' ? logoFoodAngelSit : (
                        config.REACT_APP_DEV_ENV === 'uat' ? logoFoodAngelUat : logoFoodAngel
                      )}
                    /> */}
                  </div>
                  {this._getMenuView()}
                </Sider>
              )
            }


            <Layout className="site-layout">
              <Header className="site-layout-background" style={{ padding: '0px 16px', flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }} >

                <Space align='center' >

                  <Button
                    icon={this.state.collapsed
                      ? (<MenuUnfoldOutlined />)
                      : (<MenuFoldOutlined />)}
                    onClick={() => {
                      this.setState({
                        collapsed: !this.state.collapsed,
                        openKeys: this._getOpenKeys(this.props)
                      })
                    }}

                  />
                </Space>


                <Space align='center' >
                  <Dropdown
                    overlay={(
                      <Menu>
                        <Menu.Item
                          key="0"
                          disabled={true}
                        >{this.props.user.data.contactPerson}</Menu.Item>


                        <Menu.Divider />
                        {[
                          { title: "時間模式(YYYY-MM-DD HH:mm:ss)", value: 'format' },
                          { title: "時間模式(從現在起)", value: 'fromNow' },
                        ].map((item: any) => {
                          return (
                            <Menu.Item
                              key={item.value}
                              onClick={async () => {
                                this.props.setConfigData({
                                  ...this.props.config,
                                  momentType: item.value,
                                })
                              }}
                              disabled={item.value === this.props.config.momentType}
                            >
                              {item.title}
                            </Menu.Item>
                          )
                        })}

                        <Menu.Divider />
                        <Menu.Item
                          key="1"
                          disabled={false}
                          onClick={() => this.setState({ passwordChangeModal: { ...this.state.passwordChangeModal, key: new Date().toISOString(), visible: true } })}
                        >修改密碼</Menu.Item>
                        <Menu.Divider />
                        <Menu.Item
                          danger
                          onClick={async () => {
                            try {
                              this.setState({
                                loading: true,
                              })
                              await this._deleteAuth()
                              this.setState({
                                loading: false,
                              })
                              this.props.history.replace('/login')
                            } catch (error: any) {
                              this.setState({
                                loading: false,
                              })
                            }
                          }}
                          key="2">登出</Menu.Item>
                      </Menu>
                    )}
                    trigger={['click']}
                  >
                    <Button icon={(<SettingOutlined />)} />
                  </Dropdown>
                </Space>
              </Header>
              {this.state.mainContentKey && <MainContent key={this.state.mainContentKey} />}
            </Layout>
          </Layout>
          {
            this.state.passwordChangeModal.key && (
              <UserAuthPasswordChangeModal
                key={this.state.passwordChangeModal.key}
                title='修改密碼'
                userId={this.props.user.data.id}
                visible={this.state.passwordChangeModal.visible}
                onCancel={() => this.setState({ passwordChangeModal: { ...this.state.passwordChangeModal, visible: false } })}
                onFinish={() => {
                  this.setState({ passwordChangeModal: { ...this.state.passwordChangeModal, visible: false } })
                }}
              />
            )
          }

        </Spin >
      </div >
    )
  }

}
export default connector(Main)
